<template lang="pug">
    form.start-page-form
        .start-page-form__title Восстановление пароля
        .form__text Для сброса пароля введите ваш E-mail
        .form__group
            label.form__label E-mail
            .form__full
                input(type='email' required v-model="email").form__input
        router-link(to="/change").btn Сбросить пароль
        router-link(to="/login").form__link Авторизация

</template>

<script>
export default {
  name: 'Login',
  data: function() {
    return {
      email: null,
      password: null,
    }
  },
}
</script>

<style lang="scss">

</style>
